<!-- <p-growl [life]="5000"></p-growl> -->
<div [class]="theme">
	<p-toast [showTransformOptions]="'translateX(100%)'" [baseZIndex]="10000000"></p-toast>

	<p-confirmDialog header="Confirmation" #cd [closeOnEscape]="false" [closable]="false">
		<ng-template #footer>
			@if (cd.rejectVisible) {
				<button
					type="button"
					pButton
					[icon]="cd.acceptVisible ? 'fas fa-times' : ''"
					[label]="cd.acceptVisible ? ('form.btn.no' | translate) : (cd.rejectLabel | translate)"
					class="ui-dark-button"
					(click)="cd.onReject()"></button>
			}
			@if (cd.acceptVisible) {
				<button
					type="button"
					pButton
					[icon]="cd.rejectVisible ? 'fas fa-check' : ''"
					[label]="cd.rejectVisible ? ('form.btn.yes' | translate) : ''"
					class="ui-green-button"
					(click)="cd.onAccept()"></button>
			}
		</ng-template>
	</p-confirmDialog>
	<div class="main">
		<router-outlet></router-outlet>
	</div>

	@if (loadingService.isLoading) {
		<div class="loading" @fade>
			<loader></loader>
		</div>
	}
</div>
